import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import FormContainer from '../../components/formContainer/formContainer'
import { TextInput,  ImageUploadInput } from '../../components/input/inputModule'
import { getDuzenleData } from '../helpers/componentApiHelpers/getDuzenleData'
import { sendDataUpload, changeDataUpload } from '../helpers/componentApiHelpers/sendData'
import { getIdFromUrl } from '../helpers/getIdFromUrl'
import { getCall } from '../helpers/componentApiHelpers/getCall'

class YaprakTipiEnter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            typeName: "",
            image: "",
            dataCame: false
        }
        this.onValChange = this.onValChange.bind(this)
    }

    async componentDidMount() {
        await getDuzenleData(2, "leafType", this)
    }

    async onValChange(e, stateProp) {
        e.preventDefault()
        await this.setState({ [stateProp]: e.target.value })
    }

    async send() {
        if (this.state.id === "" || this.state.id === undefined) {
            await sendDataUpload("/leafType", "/yaprakTipi", this)
        } else {
            await changeDataUpload("/leafType/", "/yaprakTipi", this)
        }
    }

    render() {
        return (
            <React.Fragment>
                <HeaderLine header="Ekle" />
                <FormContainer
                    sending={this.state.sending}
                    dataCame={getIdFromUrl(this.props.history.location.pathname, 2) !== undefined && !this.state.dataCame}
                >
                    <p className="main-paragraph">Yaprak Tipi</p>
                    <TextInput ref="typeName" label="Tip İsmi" value={this.state.typeName} stateProp="typeName" onChange={this.onValChange} />
                    <br></br><br></br>
                    <ImageUploadInput id="image" stateProp="image" value={this.state.image} onChange={this.onValChange} />
                    {this.state.errorMessage && <p style={{ color: "red" }}>{this.state.errorMessage}</p>}
                    <button onClick={() => this.send()} className="save-button">Ekle</button>
                </FormContainer>
            </React.Fragment>
        )
    }
}

export default YaprakTipiEnter